/* batida-v7-details-slot.js (new batida.pl look, 28.09): on desktop, puts the product details (tabs + barista card,
   sections/batida-v7-details.liquid) into the empty space under the gallery when the buy box is much taller than the
   pictures (Pat 28.09: "like the B2B product page - the description close to the pictures, no big white gap").

   - The details exist ONCE in the page (no copy, SEO): this script only moves the existing <section class="v7-details">
     into the slot under the thumbnails (sections/product.liquid, [data-v7-details-slot]) and back.
   - Moved on desktop whenever the buy box column is more than THRESHOLD px taller than the gallery (checked early and
     again when the page, images and buy box are ready; once moved it stays).
   - Re-decided only when the window WIDTH changes (debounced). Never while the customer toggles options, so nothing
     jumps under their hand. Below the desktop breakpoint (989 px and less: tablet, phone) the details go back to their
     original place.
   - Does nothing on b2b.batida.pl (the details section and this file are not rendered there) or when either the slot or
     the details are missing. */
(function () {
  if (window.__v7DetailsSlot) return;
  window.__v7DetailsSlot = true;

  var THRESHOLD = 250;
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var home = null;       // comment node marking the details' original place
  var moved = null;      // the details element while it sits in the slot
  var decided = false;
  var lastW = window.innerWidth;

  function q(s) { return document.querySelector(s); }
  function parts() {
    var slot = q('[data-v7-details-slot]');
    var media = slot && slot.parentElement;
    var row = media && media.parentElement;
    var main = row && row.querySelector('.product__main__content');
    var inner = main && main.querySelector('.product__inner');
    var det = moved || q('section.v7-details');
    return (slot && media && main && inner && det) ? { slot: slot, media: media, row: row, main: main, inner: inner, det: det } : null;
  }

  // Bottom of the gallery = the lowest visible, in-flow child of the media column (the slot itself excluded).
  function galleryBottom(p) {
    var b = 0;
    [].forEach.call(p.media.children, function (c) {
      if (c === p.slot) return;
      var cs = getComputedStyle(c);
      if (cs.display === 'none' || cs.position === 'absolute' || cs.position === 'fixed') return;
      var r = c.getBoundingClientRect();
      if (r.height > 0 && r.bottom > b) b = r.bottom;
    });
    return b;
  }
  // Where the content after the details starts (the next section), or the page end.
  function pageEnd(sec) {
    var n = sec && sec.nextElementSibling;
    return n ? n.getBoundingClientRect().top + window.scrollY : document.documentElement.scrollHeight;
  }
  function gap(p) { return Math.round(p.inner.getBoundingClientRect().bottom - galleryBottom(p)); }
  function twoColumns(p) {
    if (mq && !mq.matches) return false;
    var a = p.media.getBoundingClientRect(), b = p.main.getBoundingClientRect();
    return a.width > 0 && b.width > 0 && a.right <= b.left + 2 && Math.abs(a.top - b.top) < 4;
  }

  function moveIn(p) {
    if (moved) return;
    if (!home) home = document.createComment('v7-details');
    p.det.parentNode.insertBefore(home, p.det);
    p.slot.appendChild(p.det);
    p.slot.hidden = false;
    p.det.classList.add('v7-details--side');
    p.row.classList.add('v7-side-details');
    moved = p.det;
  }
  function putBack() {
    if (!moved) return;
    var slot = moved.parentElement, row = document.querySelector('.v7-side-details');
    if (home && home.parentNode) home.parentNode.insertBefore(moved, home);
    moved.classList.remove('v7-details--side');
    if (row) row.classList.remove('v7-side-details');
    if (slot && slot.hasAttribute('data-v7-details-slot')) slot.hidden = true;
    if (home && home.parentNode) home.parentNode.removeChild(home);
    moved = null;
  }

  // Pat 29.09 ("I thought we were going to fix this huge blank space"): no more "page must get shorter" test and no
  // "already scrolled" guard - a reload restores the scroll position, so the guard kept the gap exactly when Pat looked.
  // Rule now: on desktop, whenever the buy box ends more than THRESHOLD px below the gallery, the details go under
  // the gallery. Checked as early as possible and again when the page, the images and the buy box are ready; once
  // moved they stay (only a width change below the desktop breakpoint puts them back).
  function evaluate(fromResize) {
    var p = parts();
    if (!p) return;
    if (!twoColumns(p)) { putBack(); return; }
    if (moved) return;
    if (gap(p) > THRESHOLD) moveIn(p);
  }

  function start() {
    evaluate(false);
    [300, 1200, 3000, 6000].forEach(function (ms) { setTimeout(function () { evaluate(false); }, ms); });
    decided = true;
  }
  new MutationObserver(function () {
    if (document.documentElement.classList.contains('batida-pdp-ready')) evaluate(false);
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('load', function () { evaluate(false); });

  var rt = null;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;   // height-only changes (browser bars) never move anything
    lastW = window.innerWidth;
    clearTimeout(rt);
    rt = setTimeout(function () { evaluate(true); }, 250);
  });

  // Theme editor: a re-rendered section must not leave a stale copy behind.
  document.addEventListener('shopify:section:unload', function (e) {
    if (!moved) return;
    if (e.target.contains(moved)) { putBack(); return; }                                         // product section
    if (home && e.target.contains(home)) { var d = moved; putBack(); if (d.parentNode) d.parentNode.removeChild(d); } // details section
  });
  document.addEventListener('shopify:section:load', function () { decided = false; start(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
